import { c, classy } from '@onfido/castor';
import React from 'react';
import { withRef } from '../../utils';
/**
 * Use within `Fieldset` component to provide a text legend.
 */
export const FieldsetLegend = withRef(function FieldsetLegend({ className, ...restProps }, ref) {
    return (React.createElement("legend", { ...restProps, ref: ref, className: classy(c('fieldset-legend'), className) }));
});
//# sourceMappingURL=fieldset-legend.js.map